class AnalyticsService {
  push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  initialize() {
    // GTM is loaded via the HTML snippet in index.html — no JS init needed.
  }

  trackPageView(path, title = null) {
    this.push({
      event: 'page_view',
      page_path: path,
      page_title: title || document.title,
    });
  }

  trackEvent(action, category = 'General', label = null, value = null) {
    this.push({
      event: action,
      event_category: category,
      event_label: label,
      event_value: value,
    });
  }

  trackAuth(action, method = null) {
    this.trackEvent(action, 'Authentication', method);
  }

  trackOnboarding(step, action = 'step_completed') {
    this.trackEvent(action, 'Onboarding', step);
  }

  trackAdmin(action, resource = null) {
    this.trackEvent(action, 'Admin', resource);
  }

  trackFormSubmission(formName, success = true) {
    this.trackEvent(success ? 'form_submit_success' : 'form_submit_error', 'Forms', formName);
  }

  trackError(error, context = null) {
    this.trackEvent('error', 'Errors', context, error.message);
  }

  setUserProperties(properties) {
    this.push({
      event: 'set_user_properties',
      user_properties: properties,
    });
  }

  setUserId(userId) {
    this.push({
      event: 'set_user_id',
      user_id: userId,
    });
  }
}

const analyticsService = new AnalyticsService();
export default analyticsService;
